import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper";
import WebData from "../../Helpers/WebData";
import Sevak from "./Person.component";
import "./GauSevak.style.css";

function GauSevak() {
  SwiperCore.use([Pagination, Navigation]);

  return (
    <section>
      <div className="gau-sevak mt-3 mb-5">
        <h3 className="global-heading text-center">Gau Sevak</h3>
        <Swiper slidesPerView={"auto"}>
          {WebData.gauSevak.map((person, index) => {
            return (
              <SwiperSlide key={index} className="sevak">
                <Sevak person={person} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default GauSevak;
